import { useIdleTimer as useIdleTimerLibrary } from 'react-idle-timer';

import { logout } from 'redux/reducers/authenticationSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { isAuthenticatedSelector } from 'redux/selectors/authenticationSelectors';
import { IDLE_TIMEOUT } from '../constants';

export function useIdleTimer() {
  const isAuthenticated = useAppSelector(isAuthenticatedSelector);
  const dispatch = useAppDispatch();

  const handleOnIdle = () => {
    dispatch(logout());
  };

  useIdleTimerLibrary({
    timeout: IDLE_TIMEOUT,
    onIdle: isAuthenticated ? handleOnIdle : undefined,
    events: ['mousedown', 'mousemove', 'keypress', 'touchstart', 'scroll'],
    debounce: 500,
    crossTab: true,
    syncTimers: 200,
  });
}
